export const PROJECT_STAGE_OPTIONS = [
  { value: 'idea', label: 'Идея', color: '#94a3b8' },
  { value: 'prototype', label: 'Прототип', color: '#38bdf8' },
  { value: 'mvp', label: 'MVP', color: '#c084fc' },
  { value: 'working_product', label: 'Работающий продукт', color: '#34d399' },
  { value: 'scaling', label: 'Масштабирование', color: '#fbbf24' },
] as const;

export const STATUS_TAG_OPTIONS = [
  { value: 'sale', label: 'Продаётся', color: '#34d399' },
  { value: 'clients', label: 'Ищу клиентов', color: '#34d399' },
  { value: 'partner', label: 'Ищу партнёра', color: '#fb923c' },
  { value: 'investor', label: 'Ищу инвестора', color: '#fbbf24' },
  { value: 'dev', label: 'Ищу разработчика', color: '#c084fc' },
  { value: 'case', label: 'Кейс', color: '#38bdf8' },
  { value: 'opensource', label: 'Open Source', color: 'var(--border)' },
  { value: 'wip', label: 'В разработке', color: 'var(--border)' },
] as const;

const LEGACY_PROJECT_STAGE_LABELS: Record<string, string> = {
  beta: 'Бета',
  launched: 'Запущен',
  growing: 'Растёт',
};

const LEGACY_PROJECT_STAGE_VALUE_MAP: Record<string, string> = {
  beta: 'prototype',
  launched: 'working_product',
  growing: 'scaling',
};

const PROJECT_STAGE_LABELS = Object.fromEntries(
  PROJECT_STAGE_OPTIONS.map((stage) => [stage.value, stage.label]),
) as Record<string, string>;

const STATUS_TAG_LABELS = Object.fromEntries(
  STATUS_TAG_OPTIONS.map((status) => [status.value, status.label]),
) as Record<string, string>;

function normalizeProjectMetaValue(value: string | null | undefined): string {
  return String(value ?? '').trim().toLowerCase();
}

export function isProjectStageValue(value: string | null | undefined): boolean {
  const normalized = normalizeProjectMetaValue(value);
  return Boolean(PROJECT_STAGE_LABELS[normalized] || LEGACY_PROJECT_STAGE_LABELS[normalized]);
}

export function normalizeProjectStageValue(value: string | null | undefined): string {
  const normalized = normalizeProjectMetaValue(value);
  if (!normalized) return '';
  return LEGACY_PROJECT_STAGE_VALUE_MAP[normalized] ?? normalized;
}

export function getProjectStageLabel(value: string | null | undefined): string | null {
  const raw = String(value ?? '').trim();
  if (!raw) return null;
  const normalized = raw.toLowerCase();
  return PROJECT_STAGE_LABELS[normalized] ?? LEGACY_PROJECT_STAGE_LABELS[normalized] ?? raw;
}

export function getStatusTagLabel(value: string | null | undefined): string | null {
  const raw = String(value ?? '').trim();
  if (!raw) return null;
  const normalized = raw.toLowerCase();
  return STATUS_TAG_LABELS[normalized] ?? raw;
}

export function getDisplayProjectMetaLabel(value: string | null | undefined): string | null {
  return getProjectStageLabel(value) ?? getStatusTagLabel(value);
}
